"use client";

import {useState} from "react";
import {Modal, Dialog, Heading} from "react-aria-components";
import ModalBody from "./ModalBody";
import ModalOverlay from "./ModalOverlay";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import AnchorButton from "./AnchorButton";
import {ButtonVariant} from "./ButtonVariants";
import TextSection from "./cms/TextSection";
import {Block} from "@/shared/strapiTypes/common/Blocks";

export interface GenericOverlayModalProps {
	startOpen: boolean;
	title?: string;
	bodyContent?: Block[];
	buttonText?: string;
	buttonLink?: string;
	buttonId?: string;
	localStorageFieldName?: string;
}

const GenericOverlayModal: FCWithHTMLAttributes<GenericOverlayModalProps> = ({
	startOpen,
	title,
	bodyContent,
	buttonText,
	buttonLink,
	buttonId,
	localStorageFieldName,
}) => {
	const [isOpen, setOpen] = useState(startOpen);
	const dismissModal = function () {
		setOpen(false);
		if (localStorageFieldName) {
			window.localStorage.setItem(localStorageFieldName, "true");
		}
	};
	return (
		<ModalOverlay isDismissable isOpen={isOpen} onOpenChange={dismissModal}>
			<Modal className="max-h-full max-w-full overflow-auto p-4">
				<Dialog>
					<ModalBody
						onClose={() => dismissModal()}
						className="w-[51.5rem] max-w-full flex-col gap-6 rounded-xl"
					>
						{title && <Heading slot="title">{title}</Heading>}
						{bodyContent && <TextSection contents={bodyContent} />}
						{buttonLink && (
							<AnchorButton
								id={buttonId}
								variant={ButtonVariant.SECONDARY}
								href={buttonLink}
								onClick={() => dismissModal()}
							>
								{buttonText}
							</AnchorButton>
						)}
					</ModalBody>
				</Dialog>
			</Modal>
		</ModalOverlay>
	);
};

export default GenericOverlayModal;
